import { login_logService } from '../_services';
const state = { onRequest: false, login_logs: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        login_logService.get_data(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  login_logs: state => {
    return state.login_logs
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.login_logs = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_datas(state, data) {
        state.onRequest = false;
      state.login_logs = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.login_logs = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const login_logs = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
